// Floating labels for all Gravity Forms
// Only applies to text-type inputs and textareas (not select, file, checkbox, etc.)
// Fields with .normal-label class are skipped.
// - Moves label inside .ginput_container for correct absolute positioning
// - Adds .gfield--filled class when an input/textarea has a value
// - Re-initializes after GF AJAX page navigation (gform_post_render)
(function () {
  var floatTypes = [
    'gfield--type-text',
    'gfield--type-email',
    'gfield--type-phone',
    'gfield--type-name',
    'gfield--type-website',
    'gfield--type-number',
    'gfield--type-textarea',
  ];

  function isFloatField(field) {
    if (field.classList.contains('normal-label')) return false;
    return floatTypes.some(function (cls) {
      return field.classList.contains(cls);
    });
  }

  function updateFilled(gfield) {
    var input = gfield.querySelector(
      'input:not([type="hidden"]):not([type="file"]), textarea'
    );
    if (!input) return;
    gfield.classList.toggle('gfield--filled', input.value.length > 0);
  }

  function initWrapper(wrapper) {
    var fields = wrapper.querySelectorAll('.gfield');

    // Move labels inside ginput_container (only for float-eligible fields)
    fields.forEach(function (field) {
      if (!isFloatField(field)) return;

      // Remove hidden_label so the label becomes visible for floating
      field.classList.remove('hidden_label');

      var label = field.querySelector('.gfield_label.gform-field-label');
      var container = field.querySelector('.ginput_container');

      // For name fields (fieldset), the label is a <legend> — find the first ginput_container
      if (!label) {
        label = field.querySelector('legend.gfield_label.gform-field-label');
      }

      if (label && container && label.parentElement !== container) {
        container.prepend(label);
      }
    });

    // Bind input events for filled state (only for float-eligible fields)
    fields.forEach(function (field) {
      if (!isFloatField(field)) return;
      var inputs = field.querySelectorAll(
        'input:not([type="hidden"]):not([type="file"]), textarea'
      );
      inputs.forEach(function (input) {
        input.addEventListener('input', function () { updateFilled(field); });
        input.addEventListener('change', function () { updateFilled(field); });
      });
      updateFilled(field);
    });
  }

  // Initial run
  var wrappers = document.querySelectorAll('.gform_wrapper');
  if (!wrappers.length) return;
  wrappers.forEach(initWrapper);

  // Re-initialize after GF AJAX page navigation
  if (typeof jQuery !== 'undefined') {
    jQuery(document).on('gform_post_render', function (event, formId) {
      var wrapper = document.getElementById('gform_wrapper_' + formId);
      if (wrapper) initWrapper(wrapper);
    });
  }
})();
